"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LunarTradeFleet = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var MoonExpansion_1 = require("../../moon/MoonExpansion");
var CardRenderer_1 = require("../render/CardRenderer");
var CardRequirements_1 = require("../CardRequirements");
var Card_1 = require("../Card");
var LunarTradeFleet = (function (_super) {
    __extends(LunarTradeFleet, _super);
    function LunarTradeFleet() {
        return _super.call(this, {
            name: CardName_1.CardName.LUNAR_TRADE_FLEET,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.SPACE],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.production(Resources_1.Resources.TITANIUM, 2); }),
            metadata: {
                description: 'Requires that you have 2 titanium production. ' +
                    'Increase your M€ production 1 step. Raise the Logistic Rate 1 step.',
                cardNumber: 'M35',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1); });
                    b.br;
                    b.moonLogisticsRate();
                }),
            },
        }) || this;
    }
    ;
    LunarTradeFleet.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1, { log: true });
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
        return undefined;
    };
    return LunarTradeFleet;
}(Card_1.Card));
exports.LunarTradeFleet = LunarTradeFleet;
//# sourceMappingURL=LunarTradeFleet.js.map